var _path, _path2, _path3, _path4, _g, _path5, _path6, _rect, _path7, _path8, _path9, _g2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _g3, _path37, _path38, _path39, _g4, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoPostsBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 246,
    viewBox: "0 0 324 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266.484 171.771H31.603C31.603 171.771 12.1954 175.141 13.135 185.814C14.0746 196.486 49.2091 184.654 54.8338 201.573C60.4584 218.492 107.322 222.251 147.362 208.662C187.402 195.074 201.943 219.432 222.562 219.432C243.181 219.432 243.298 197.763 263.386 201.567C283.474 205.37 292.442 197.724 284.621 189.903L266.484 171.771Z",
    fill: "#E4E6EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2954 171.771H263.38",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M249.966 28H44.7573V145.942H249.966V28Z",
    fill: "#E4E6EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9993_30999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 28,
    width: 206,
    height: 118
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M249.966 28H44.7573V145.942H249.966V28Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9993_30999)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M249.966 28H44.7573V145.942H249.966V28Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M249.966 28H44.7573V145.942H249.966V28Z",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M249.966 28H44.7573V39.9426H249.966V28Z",
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 30,
    width: 8,
    height: 8,
    fill: "url(#pattern0)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.043 31.1553H57.3933V36.7799H154.043V31.1553Z",
    fill: "white",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2392 31.1553H57.3933V36.7799H75.2392V31.1553Z",
    fill: "#E4E6EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9993_30999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 31,
    width: 19,
    height: 6
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2392 31.1553H57.3933V36.7799H75.2392V31.1553Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9993_30999)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M75.2392 31.1553H57.3933V36.7799H75.2392V31.1553Z",
    fill: "white",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2392 31.1553H57.3933V36.7799H75.2392V31.1553Z",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M158.365 99.7275H90.072V105.352H158.365V99.7275Z",
    fill: "white",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M247.517 111.333H193.862V116.958H247.517V111.333Z",
    fill: "white",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M247.517 122.627H193.862V128.252H247.517V122.627Z",
    fill: "white",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M247.517 133.922H193.862V139.547H247.517V133.922Z",
    fill: "white",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M107.918 99.7275H90.072V105.352H107.918V99.7275Z",
    fill: "#E4E6EB",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M186.721 111.333H90.072V139.547H186.721V111.333Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M247.316 44.1611H90.072V53.3174H247.316V44.1611Z",
    fill: "white",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M247.316 57.5293H90.072V93.7395H247.316V57.5293Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M119.109 44.1611H90.072V53.3174H119.109V44.1611Z",
    fill: "#E4E6EB",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M111.637 60.5811H92.178V66.7176H111.637V60.5811Z",
    fill: "#E4E6EB",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M213.322 102.28H193.862V108.417H213.322V102.28Z",
    fill: "#E4E6EB",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6081 86.1318H50.1487V92.2684H69.6081V86.1318Z",
    fill: "#E4E6EB",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M214.708 69.6533H92.178V72.7184H214.708V69.6533Z",
    fill: "white",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2038 95.1133H50.3755V98.1783H64.2038V95.1133Z",
    fill: "white",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6081 103.835H50.1487V109.972H69.6081V103.835Z",
    fill: "#E4E6EB",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M67.716 112.816H50.3755V115.881H67.716V112.816Z",
    fill: "white",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M65.61 118.733H50.3755V121.798H65.61V118.733Z",
    fill: "white",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0913 124.649H50.3755V127.714H62.0913V124.649Z",
    fill: "white",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M67.716 130.565H50.3755V133.63H67.716V130.565Z",
    fill: "white",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2038 136.475H50.3755V139.54H64.2038V136.475Z",
    fill: "white",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M224.551 75.6543H92.178V78.7193H224.551V75.6543Z",
    fill: "white",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M209.557 81.6611H92.178V84.7262H209.557V81.6611Z",
    fill: "white",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M221.273 87.6611H92.178V90.7262H221.273V87.6611Z",
    fill: "white",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M247.316 31.1553H241.691V36.7799H247.316V31.1553Z",
    fill: "#E4E6EB",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M233.442 31.1553H227.817V36.7799H233.442V31.1553Z",
    fill: "#E4E6EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9993_30999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 227,
    y: 31,
    width: 7,
    height: 6
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M233.442 31.1553H227.817V36.7799H233.442V31.1553Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9993_30999)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M233.442 31.1553H227.817V36.7799H233.442V31.1553Z",
    fill: "white"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M233.442 31.1553H227.817V36.7799H233.442V31.1553Z",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M240.376 31.1553H234.751V36.7799H240.376V31.1553Z",
    fill: "#E4E6EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9993_30999",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 234,
    y: 31,
    width: 7,
    height: 6
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M240.376 31.1553H234.751V36.7799H240.376V31.1553Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9993_30999)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M240.376 31.1553H234.751V36.7799H240.376V31.1553Z",
    fill: "white"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M240.376 31.1553H234.751V36.7799H240.376V31.1553Z",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5144 44.1611H50.1487V80.5269H86.5144V44.1611Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1782 49.5002C67.1782 49.5002 60.8602 49.2669 61.6831 51.1526C62.5061 53.0383 57.672 53.4595 58.8384 55.5201C60.0048 57.5807 56.6417 60.3736 58.3394 61.4623C60.0372 62.5509 59.2531 64.6051 58.4431 65.6872C57.6331 66.7694 59.7391 68.1755 61.4045 68.1561C63.0698 68.1367 60.7565 70.1001 61.4045 70.5731C62.0525 71.0462 62.9921 69.3743 64.2298 69.7243C65.4674 70.0742 68.2733 68.9985 69.0379 69.2966C69.8026 69.5947 79.8401 70.1843 79.9308 69.5039C80.0215 68.8235 79.0042 68.7069 79.218 68.0395C79.4318 67.372 81.0778 68.0395 81.4147 66.6074C81.7517 65.1753 80.4622 64.5079 80.6566 63.1147C80.851 61.7215 81.8942 62.3435 82.1275 60.4384C82.3608 58.5333 79.6003 57.9436 79.5355 56.9716C79.4707 55.9996 82.1729 56.3236 81.3823 54.4963C80.5918 52.6689 77.7082 52.967 77.0731 51.9043C76.4381 50.8415 78.8033 50.9582 77.274 49.5131C75.7447 48.0681 69.6341 47.1544 67.1782 49.5002Z",
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M60.426 64.6836C59.6938 66.2388 61.074 66.511 62.3182 66.9322C63.5623 67.3534 62.843 69.1872 62.843 69.1872",
    stroke: "#7F7F7F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7585 61.3076C60.3945 62.0628 60.7066 63.0386 60.6269 64.0227",
    stroke: "#7F7F7F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1279 56.4209C60.0178 57.8983 58.5663 60.0303 59.2207 60.6912",
    stroke: "#7F7F7F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4672 52.9482C62.4672 52.9482 59.1948 54.2442 59.9724 55.5402",
    stroke: "#7F7F7F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5773 51.4443C62.7458 51.7683 63.2253 51.7943 63.2253 52.2543",
    stroke: "#7F7F7F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6856 50.22C66.6856 50.22 62.7199 50.1811 62.5449 50.9911",
    stroke: "#7F7F7F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6306 59.9922C80.3195 60.8735 78.5311 62.5842 79.2309 64.1135C79.9307 65.6427 80.4427 66.2195 79.1596 66.5888",
    stroke: "#7F7F7F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4513 54.8789C79.1856 55.8315 77.611 55.7019 77.8118 57.3283C77.9479 58.4818 79.4513 58.89 80.2159 59.3436",
    stroke: "#7F7F7F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8743 51.458C75.8743 52.6698 74.7209 52.8383 76.3214 53.7455C77.0244 54.1406 77.8155 54.3523 78.6218 54.361",
    stroke: "#7F7F7F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9039 50.356C67.9039 50.356 74.8505 48.412 75.6799 50.518",
    stroke: "#7F7F7F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5526 66.627C77.2415 67.5082 78.2006 68.733 78.2006 68.733",
    stroke: "#7F7F7F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6195 55.6953C76.7556 56.7451 75.7253 57.1468 75.9715 58.2873C76.2178 59.4278 78.2136 59.1816 78.3108 60.0369C78.408 60.8923 76.7232 61.8384 77.112 63.5426C77.3129 64.3915 77.5008 64.9488 77.6045 65.4088",
    stroke: "#7F7F7F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0404 53.8291C74.2802 54.84 75.1744 54.9177 75.8418 55.0862",
    stroke: "#7F7F7F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4552 51.9375C74.3838 52.2852 74.2638 52.6212 74.0988 52.9354",
    stroke: "#7F7F7F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9773 51.1859C66.9773 51.1859 73.7813 49.4104 74.3451 51.0887",
    stroke: "#7F7F7F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9347 63.1475C75.0837 63.7955 75.7706 64.275 75.7512 65.1627C75.7188 66.3551 75.2133 67.1586 75.7512 68.2407",
    stroke: "#7F7F7F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2974 54.127C72.3779 54.6053 72.5557 55.062 72.8199 55.4689C73.0841 55.8757 73.4289 56.224 73.8331 56.4922C74.844 57.1985 74.5265 58.5917 75.1291 59.5248C75.7318 60.4579 75.479 61.4688 74.9995 62.4732",
    stroke: "#7F7F7F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M65.759 51.9762C65.759 51.9762 71.8632 51.5291 72.1289 53.2722",
    stroke: "#7F7F7F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0548 51.6261C64.0548 51.6261 64.3399 50.7513 65.8303 51.341",
    stroke: "#7F7F7F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1214 72.3941C62.5838 71.6943 66.1672 70.502 70.4894 70.502C73.2693 70.502 75.7317 71.3249 77.9025 71.8433C80.2158 72.4006 83.3133 72.5431 81.9266 80.4747H57.3026C57.3026 80.4747 56.4861 73.418 60.1214 72.3941Z",
    fill: "#E4E6EB",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7962 68.7853L71.5002 63.543L67.9362 64.6187L66.867 68.8695C66.7655 69.2783 66.5753 69.6597 66.3099 69.9867C66.0445 70.3137 65.7104 70.5783 65.3313 70.7617C64.795 71.008 64.2849 71.3076 63.8085 71.6559C63.8085 71.6559 68.0399 77.4296 76.1594 71.6559C75.6206 71.265 75.0377 70.9387 74.4227 70.6839C74.023 70.5152 73.668 70.2558 73.3857 69.9263C73.1035 69.5968 72.9017 69.2062 72.7962 68.7853Z",
    fill: "white",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M61.709 55.7735L61.2424 58.8774C61.1964 59.2054 61.2229 59.5394 61.3202 59.8559L61.5923 60.7113L61.4303 62.733C61.4238 62.8388 61.4238 62.9448 61.4303 63.0506C61.5016 64.0874 62.0006 69.5954 64.9943 69.8286C67.6511 70.0295 70.295 66.7442 71.2346 65.4417C71.4666 65.1174 71.6358 64.7526 71.7335 64.366L72.1353 62.7849C72.5132 62.7826 72.8808 62.6612 73.1857 62.4378C73.4905 62.2144 73.7171 61.9004 73.8331 61.5407C74.2348 60.2447 74.9023 59.4412 73.6127 58.8126C72.3232 58.1841 71.8631 59.9661 71.8631 59.9661C71.7333 59.0451 71.503 58.1412 71.1763 57.2704C70.8652 56.7455 69.7247 56.104 69.3878 55.5921C69.1999 55.1872 69.0481 54.7665 68.9342 54.335C68.9342 54.335 65.0462 55.0866 62.033 54.484L61.709 55.7735Z",
    fill: "white",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M63.504 61.2031L62.4413 63.7951C62.4074 63.8793 62.3938 63.9703 62.4017 64.0607C62.4096 64.1512 62.4388 64.2384 62.4868 64.3155C62.5347 64.3925 62.6002 64.4571 62.6779 64.5041C62.7556 64.551 62.8432 64.579 62.9338 64.5857L64.2298 64.6699",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4827 65.124C66.6339 66.5626 65.6035 66.258 64.975 65.8563",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M65.111 60.8924C65.111 61.333 65.2794 61.6894 65.4803 61.6894C65.6812 61.6894 65.8562 61.333 65.8562 60.8924C65.8562 60.4517 65.6877 60.0889 65.4803 60.0889C65.273 60.0889 65.111 60.4517 65.111 60.8924Z",
    fill: "#AEAEAE"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0006 60.8924C62.0006 61.333 62.1691 61.6894 62.37 61.6894C62.5709 61.6894 62.7458 61.333 62.7458 60.8924C62.7458 60.4517 62.5773 60.0889 62.37 60.0889C62.1626 60.0889 62.0006 60.4517 62.0006 60.8924Z",
    fill: "#AEAEAE"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M64.975 59.1299C65.4118 58.9915 65.8834 59.0118 66.3067 59.1873C66.7299 59.3627 67.0776 59.6821 67.2883 60.0889",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0504 59.0129C63.0504 59.0129 61.8969 58.3649 61.3202 59.8488",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8062 53.7126C61.8062 53.7126 62.7717 57.309 64.5018 57.7237C66.232 58.1384 67.4697 58.4106 67.8196 59.9334C68.1695 61.4562 70.1718 61.7283 71.0013 62.8364C71.8307 63.9445 70.3533 68.4611 72.1742 69.1091C71.929 68.0868 71.929 67.021 72.1742 65.9987C72.5889 64.3592 73.6581 62.7586 72.8805 59.8621C72.1029 56.9655 68.649 53.7126 68.649 53.7126L65.1693 53.2979L61.8062 53.7126Z",
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3679 54.335C63.7503 54.9192 64.2525 55.4155 64.8412 55.7909C65.43 56.1663 66.0918 56.4122 66.7829 56.5122C69.1675 56.8816 69.1675 59.5514 70.2756 60.2901C71.3837 61.0288 72.6862 61.2038 72.0252 64.6382",
    stroke: "#7F7F7F",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M243.152 184.936C243.257 184.937 243.359 184.9 243.439 184.831C243.518 184.762 243.569 184.666 243.583 184.562C243.604 184.429 245.584 170.917 247.288 152.698C248.17 143.269 250.407 136.668 252.129 132.796C253.992 128.596 255.67 126.599 255.687 126.578C255.762 126.49 255.799 126.376 255.79 126.261C255.78 126.146 255.726 126.039 255.638 125.965C255.55 125.89 255.436 125.853 255.321 125.862C255.206 125.872 255.099 125.926 255.025 126.014C254.741 126.345 248.14 134.272 246.418 152.616C244.697 170.809 242.739 184.304 242.718 184.437C242.709 184.494 242.711 184.552 242.725 184.608C242.739 184.664 242.764 184.717 242.798 184.763C242.833 184.809 242.876 184.848 242.926 184.877C242.976 184.906 243.031 184.925 243.088 184.932L243.152 184.936Z",
    fill: "#E4E6EB",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M248.424 174.695H248.346C248.276 174.685 248.208 174.661 248.146 174.625C248.085 174.588 248.031 174.54 247.988 174.483C247.945 174.426 247.914 174.361 247.897 174.292C247.879 174.222 247.876 174.15 247.886 174.08C247.886 173.981 249.314 164.333 250.532 151.329C251.763 138.132 256.557 132.395 256.737 132.167C256.834 132.07 256.965 132.012 257.102 132.006C257.24 132 257.375 132.046 257.48 132.135C257.585 132.225 257.652 132.35 257.668 132.487C257.685 132.624 257.649 132.762 257.568 132.873C257.521 132.929 252.813 138.613 251.612 151.428C250.395 164.467 248.979 174.14 248.962 174.235C248.942 174.363 248.877 174.48 248.778 174.565C248.679 174.649 248.554 174.695 248.424 174.695Z",
    fill: "#E4E6EB",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M264.38 122.705C264.562 122.682 264.746 122.729 264.895 122.837C265.043 122.945 265.145 123.105 265.18 123.286C265.903 126.939 269.01 144.522 261.738 142.219C255.687 140.292 256.083 135.868 256.681 133.729C256.71 133.63 256.71 133.525 256.681 133.425C256.652 133.326 256.596 133.237 256.518 133.168C256.441 133.1 256.345 133.055 256.243 133.038C256.141 133.022 256.036 133.035 255.941 133.075C253.583 134.048 248.45 135.584 247.882 130.765C247.219 125.201 261.135 123.135 264.38 122.705Z",
    fill: "#E4E6EB"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M257.783 131.005C256.281 131.229 251.41 132.029 251.72 130.575C252.03 129.12 258.252 130.145 258.566 129.568C258.88 128.991 255.532 127.442 256.075 126.556C256.617 125.669 259.186 128.875 259.732 128.527C260.279 128.178 262.065 123.918 263.076 124.882C264.087 125.846 260.666 128.583 260.744 129.546C260.821 130.51 264.087 130.278 264.474 131.328C264.862 132.378 260.666 130.351 260.434 130.975C260.201 131.599 264.634 136.81 263.231 137.589C261.828 138.368 259.074 130.816 257.783 131.005Z",
    fill: "#BCBCBC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M267.388 101.008C267.643 100.975 267.901 101.04 268.109 101.191C268.318 101.341 268.461 101.565 268.511 101.817C269.513 106.925 273.859 131.509 263.674 128.264C255.218 125.575 255.773 119.387 256.613 116.401C256.651 116.262 256.649 116.115 256.608 115.976C256.567 115.838 256.488 115.714 256.38 115.619C256.272 115.523 256.139 115.46 255.997 115.436C255.855 115.412 255.709 115.429 255.576 115.484C252.275 116.848 245.102 118.991 244.31 112.257C243.398 104.498 262.852 101.581 267.388 101.008Z",
    fill: "#E4E6EB"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M255.446 114.271C253.39 114.469 247.004 113.819 247.882 110.94C248.759 108.062 255.924 112.029 257.086 111.25C258.248 110.471 255.283 106.263 257.15 105.454C259.018 104.645 259.414 109.327 260.111 109.288C260.808 109.249 264.156 103.264 265.559 104.017C266.962 104.77 262.116 109.542 261.824 110.94C261.531 112.339 267.344 111.095 267.736 112.421C268.128 113.746 261.591 112.632 261.281 113.574C260.972 114.516 267.271 119.809 265.64 122.064C264.01 124.319 260.313 113.806 255.446 114.271Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M247.365 173.593C247.248 173.592 247.135 173.548 247.049 173.468C246.963 173.389 246.91 173.28 246.9 173.163C246.302 167.999 245.756 162.745 245.278 157.594C243.604 139.719 237.038 131.836 236.973 131.776C236.926 131.73 236.889 131.675 236.865 131.615C236.84 131.554 236.829 131.489 236.831 131.424C236.833 131.359 236.849 131.295 236.877 131.236C236.905 131.177 236.945 131.125 236.995 131.082C237.045 131.04 237.102 131.008 237.165 130.989C237.228 130.971 237.293 130.965 237.358 130.973C237.423 130.982 237.485 131.003 237.541 131.037C237.597 131.07 237.646 131.115 237.683 131.169C237.959 131.496 244.508 139.345 246.208 157.525C246.685 162.668 247.232 167.896 247.83 173.072C247.836 173.135 247.83 173.198 247.812 173.258C247.794 173.318 247.764 173.373 247.724 173.421C247.684 173.47 247.634 173.509 247.579 173.538C247.523 173.567 247.462 173.584 247.4 173.589L247.365 173.593Z",
    fill: "#E4E6EB",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M224.567 125.717C224.367 125.79 224.202 125.933 224.101 126.121C224.001 126.308 223.974 126.526 224.025 126.733C225.14 130.924 230.88 150.895 237.313 144.746C242.653 139.642 239.977 135.218 238.26 133.291C238.18 133.201 238.127 133.092 238.106 132.974C238.085 132.856 238.098 132.734 238.143 132.623C238.188 132.512 238.263 132.416 238.359 132.345C238.456 132.274 238.571 132.232 238.69 132.224C241.655 132.038 247.804 131.019 245.932 125.691C243.789 119.572 228.169 124.504 224.567 125.717Z",
    fill: "#E4E6EB"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M235.923 134.323C236.061 136.276 236.62 142.215 235.144 141.595C233.668 140.975 234.52 134.671 233.587 133.815C232.653 132.959 230.712 138.329 229.933 136.849C229.154 135.369 231.801 133.023 231.723 131.982C231.646 130.941 226.99 128.372 227.364 127.438C227.739 126.504 232.033 129.693 232.498 128.918C232.963 128.144 233.509 124.559 234.68 124.951C235.85 125.342 234.68 128.604 235.144 129.073C235.609 129.542 240.433 124.559 241.212 127.051C241.965 129.456 235.437 127.477 235.923 134.323Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M251.526 186.072H244.762C243.495 186.071 242.276 185.585 241.358 184.712C240.439 183.839 239.891 182.647 239.826 181.382L239.133 168.042H257.15L256.462 181.382C256.397 182.647 255.849 183.839 254.93 184.712C254.012 185.585 252.793 186.071 251.526 186.072Z",
    fill: "#AEAEAE",
    stroke: "#AEAEAE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_9993_30999",
    transform: "scale(0.0222222)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_9993_30999",
    width: 45,
    height: 45,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPostsBg);
export default __webpack_public_path__ + "static/media/no-posts-bg.19c63422697b08412db81daa46ea0c1b.svg";
export { ForwardRef as ReactComponent };